/**
 * Do not edit directly
 * Generated on Tue, 07 Feb 2023 13:10:43 GMT
 */

export default "PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik02LjAyIDEyLjk5SDJWNi4wOTkzOUw3Ljc3OTk5IDkuNDJIOC4yNzk5OUwxNCA2LjEyODc5VjEwSDE1VjJIMVYxMy45OUg2LjAyVjEyLjk5Wk0yIDNWNC45NDIyN0w4LjAyOTk5IDguNDFMMTQgNC45NzEyN1YzSDJaTTguODYgMTMuODVMOC4xNiAxMy4xNUwxMS41MSA5Ljc4OTk4TDE0Ljg2IDEzLjE1TDE0LjE2IDEzLjg1TDEyLjAxIDExLjcxVjE2SDExLjUxSDExLjAxVjExLjcxTDguODYgMTMuODVaIiBmaWxsPSJpbmhlcml0Ii8+";